// Il token del link per l'amministratore (preventivatore, spec § 8) non esce dal portale: si toglie dagli eventi e dalle
// briciole mandati a Sentry. Solo il token (frammento /p/#…, percorso dei file, intestazione X-Copia-Token): il resto
// resta per il debug. Stessa regola del backend (app/riservato.py).

const NASCOSTO = "…";
const FILE = /(\/api\/preventivo\/copia\/file\/)[^/?#\s"']+/g;
const PAGINA = /(\/p\/?#)[^\s"'?&]+/g;

/** Copia di `x` senza il token. Un riferimento circolare diventa «[circolare]» (senza, il filtro andrebbe in overflow
 *  e Sentry perderebbe l'evento). */
export function togliToken<T>(x: T, strada: WeakSet<object> = new WeakSet()): T {
  if (typeof x === "string") return x.replace(FILE, `$1${NASCOSTO}`).replace(PAGINA, `$1${NASCOSTO}`) as T;
  if (x === null || typeof x !== "object") return x;
  if (strada.has(x)) return "[circolare]" as T;
  strada.add(x);
  try {
    if (Array.isArray(x)) return x.map((v) => togliToken(v, strada)) as T;
    return Object.fromEntries(Object.entries(x as Record<string, unknown>).map(([k, v]) => [
      k, k.toLowerCase() === "x-copia-token" && v ? NASCOSTO : togliToken(v, strada),
    ])) as T;
  } finally {
    strada.delete(x);           // solo gli antenati contano: lo stesso oggetto in due rami non è un ciclo
  }
}

export const filtriSentry = {
  beforeSend: <T>(evento: T): T => togliToken(evento),
  beforeSendTransaction: <T>(transazione: T): T => togliToken(transazione),
  beforeBreadcrumb: <T>(briciola: T): T => togliToken(briciola),
};
